import { RefObject, useState } from 'react';
import { useIntersecting } from './useIntersecting';

type UseOnComponentVisibleProps = {
  domNode?: HTMLElement | null;
  onBecomingVisible?: () => void;
  ref: RefObject<HTMLElement | null>;
  rootMargin?: string;
};

export const useOnComponentVisible = ({
  domNode,
  ref,
  rootMargin = '0px',
  onBecomingVisible,
}: UseOnComponentVisibleProps) => {
  const [viewed, setViewed] = useState(false);

  const [isIntersecting] = useIntersecting({
    domNode: domNode,
    callback: () => ref.current,
    rootMargin: rootMargin,
  });

  if (isIntersecting && !viewed) {
    setViewed(true);
    if (onBecomingVisible) {
      onBecomingVisible();
    }
  }
};
